export default __webpack_public_path__ + "static/media/OUTSTANDINGPAYMENT_SAVE1.6d736d1c.png";